import React, { useEffect, useState } from "react";
import { Backdrop, Box } from "@mui/material";
import http from "../../../utils/http";
import { errorToastMessage } from "../../../utils/toast";
import Loader from "../../Common/assets/Loader";
import {
  formatRegistryAgeGroupData,
  formatRegistryGenderData,
  ParticipantDashboardCards,
} from "./../../Dashboard/DashboardContent/dashboard";
import GenderPieChart from "./Insights/GenderPieChart";
import AgeGroupGraph from "./Insights/AgeGroupGraph";
import PlatformStatsCard from "./Insights/PlatformStatsCard";

const PlatformDashboardContent = () => {
  const [loading, setLoading] = useState(true);
  const [cardData, setCardData] = useState<any>(null);
  const [genderData, setGenderData] = useState<any>({});
  const [ageData, setAgeData] = useState<any>({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const [
          dashboardRes,
          // statusCountsRes
        ] = await Promise.all([
          http.get("/admin/registry/participants/dashboard"),
          // axios.get(
          //   "https://83cc3da17493.ngrok-free.app/participant_status_counts",
          //   {
          //     headers: {
          //       "ngrok-skip-browser-warning": true,
          //     },
          //   }
          // ),
        ]);
        const dashboardData = dashboardRes.data.data;
        // const statusCountsData = statusCountsRes.data;

        const cardValues = {
          total_participants: dashboardData?.totalParticipants || 0,
          merged: dashboardData?.duplicateStatus?.merged || 0,
          unique: dashboardData?.duplicateStatus?.notDuplicate || 0,
          pendingReview: dashboardData?.duplicateStatus?.pendingReview || 0,
        };

        const cardData = ParticipantDashboardCards.map((card) => ({
          ...card,
          value: cardValues[card.key as keyof typeof cardValues] || 0,
        }));
        setCardData(cardData);
        const genderData = formatRegistryGenderData(
          dashboardData?.genderDistribution
        );
        setGenderData(genderData);

        const ageData = formatRegistryAgeGroupData(
          dashboardData?.ageDistribution
        );
        setAgeData(ageData);

        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      {loading ? (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      ) : (
        <>
          <Box
            sx={{ display: "flex", gap: 2, alignItems: "flex-start", mb: 2 }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                gridGap: "16px",
                width: "100%",
              }}
            >
              {cardData?.map((item: any) => (
                <Box key={item?.key}>
                  <PlatformStatsCard data={item} />
                </Box>
              ))}
            </Box>
          </Box>
          <Box mb={2}>
            <GenderPieChart data={genderData} />
          </Box>
          <Box mb={2}>
            <AgeGroupGraph data={ageData} />
          </Box>
        </>
      )}
    </>
  );
};

export default PlatformDashboardContent;
